import React from 'react'
import {
    Box,
    Button,
    Card,
    Grid,
    IconButton,
    Stack,
    Typography,
    Dialog,
    TextField,
    Tooltip,
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Icon,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Tabs,
    Tab,
    Switch,
    FormGroup,
    FormControlLabel,
    FormLabel,
    List,
    ListItem,
    ListItemButton,
    FormHelperText,
  } from "@mui/material";
  import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CommonQuillEditor from 'common/editor';
import NoDataFound from 'common/component/NoDataFound';
import { AgGridTable } from 'components/tables/AgGridTable';
import MDButton from 'components/MDButton';
import { openCustomModalDialog } from '../../../../redux/slices/modalSlice';
import EditableAccordionHeader from '../components/EditableAccordionHeader';

function HeroSection({
    heroOpen,
    setHeroOpen,
    formData = {},
    setFormData,
    errors = {},
    setErrors,
    mainGridApiRef,
    getRows,
    pageRef,
    loading,
    columnDefs,
    handleAddBanner,
    dispatch,
    // Heading editing props
    sectionHeading,
    isEditingHeading,
    tempHeadingValue,
    setTempHeadingValue,
    onEditHeading,
    onSaveHeading,
    onCancelHeading,
}) {
  return (
   <>
       {/********************** Hero Section **********************/}
       <Accordion expanded={heroOpen} onChange={() => setHeroOpen(!heroOpen)}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panelhero-content"
              id="panelhero-header"
            >
              <EditableAccordionHeader
                sectionKey="heroSection"
                heading={sectionHeading}
                isEditing={isEditingHeading}
                tempValue={tempHeadingValue}
                setTempValue={setTempHeadingValue}
                onEdit={onEditHeading}
                onSave={onSaveHeading}
                onCancel={onCancelHeading}
              />
            </AccordionSummary>
            <AccordionDetails>
              <Grid container direction="row" spacing={3}>
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="h1"
                    fontWeight="medium"
                    color="#9A9AAF"
                    mb={1}
                    style={{ fontSize: "14px" }}
                  >
                    (H1)
                  </Typography>
                  <TextField
                    label=""
                    className="form-input"
                    fullWidth
                    placeholder=""
                    name="heroTitle"
                    value={formData?.heroSection?.title}
                    error={Boolean(errors?.heroTitle)}
                    helperText={errors?.heroTitle}
                    onChange={(e) => {
                      setErrors((prev) => ({ ...prev, heroTitle: "" }));
                      setFormData((prev) => ({
                        ...prev,
                        heroSection: {
                          ...prev.heroSection,
                          title: e.target.value,
                        },
                      }));
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="#9A9AAF"
                    mb={1}
                    name="heroSectionPara" //        ************* herosectionpara added *****************
                    style={{ fontSize: "14px" }}
                  >
                    Paragraph (P)
                  </Typography>

                  <Box width={"100%"} name={`heroSectionPara`}>
                    <CommonQuillEditor
                      allowHeading={false}
                      // allowImage={false}
                      // value={faq?.question || ''}
                      // onChange={(value) => handleChangeFAQ(value, 'question', idx)}
                      value={formData?.heroSection?.heroSectionPara}
                      error={Boolean(errors?.heroSectionPara)}
                      helperText={errors?.heroSectionPara}
                      onChange={(value) => {
                        setErrors((prev) => ({ ...prev, heroSectionPara: "" }));
                        setFormData((prev) => ({
                          ...prev,
                          heroSection: {
                            ...prev?.heroSection,
                            heroSectionPara: value,
                          },
                        }));
                      }}
                    />
                    {!!errors?.heroSectionPara && (
                      <FormHelperText error>{errors?.heroSectionPara}</FormHelperText>
                    )}
                  </Box>
                </Grid>

                <Grid item xs={12} md={12}>
                  <Typography
                    variant="h5"
                    fontWeight="semibold"
                    style={{ color: "#2E2E3A" }}
                    mb={2}
                    error={!!errors.heroBanners}
                    helperText={errors.heroBanners}
                    name={"heroBannersActive" || "heroBanners"}
                  >
                    Banners
                  </Typography>

                  {formData.heroSection?.banners?.length === 0 && errors.heroBanners && (
                    <Typography
                      color="error"
                      sx={{ variant: "body2", mt: 1 }}
                      style={{ fontSize: "14px" }}
                      name="heroBanners"
                    >
                      {!!errors.heroBanners || !!errors.heroBannersActive}
                    </Typography>
                  )}
                  {!formData?.heroSection?.banners?.length > 0 ? (
                    <NoDataFound />
                  ) : (
                    <>
                      <AgGridTable
                        col={columnDefs}
                        getRows={getRows}
                        mainGridApiRef={mainGridApiRef}
                        pageRef={pageRef}
                        isLoading={loading}
                        style={{ height: "340px" }}
                        gridOptions={{
                          rowHeight: 100,
                        }}
                      />
                    </>
                  )}
                </Grid>
                <Grid item xs={12} md={12}>
                  <Box display="flex" justifyContent="space-between" alignItems={"center"}>
                    <MDButton
                      type="button"
                      color="primary"
                      size="medium"
                      variant="outlined"
                      onClick={() =>
                        dispatch(
                          openCustomModalDialog({
                            modal: "ADD_HOME_BANNER",
                            modalData: {
                              onSubmit: handleAddBanner,
                            },
                          })
                        )
                      }
                      sx={{ minWidth: "170px", fontSize: "14px" }}
                    >
                      <Icon>add</Icon>&nbsp;Add Banner
                    </MDButton>
                  </Box>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
   </>
  )
}

export default HeroSection